module.exports = __webpack_public_path__ + "3309ba23d98b750598c3b8588958881f.pdf";